import { handleAxiosError } from "Helpers/responses";

export default {
  methods: {
    changeUserRole(user, role_key) {
      const target_user = _.find(this.users, { uuid: user.uuid });
      const target_user_index = _.findIndex(this.users, { uuid: user.uuid });
      if (!target_user) {
        toastr.error("User no longer exists");
        return;
      }
      const url = `/api/v1/user/roles/${user.uuid}/change-role`;

      axios.patch(url, { role_key: role_key }).then((response) => {
        toastr.success("User Role Updated");
        Vue.set(this.users, target_user_index, response.data.data);
      }).catch((error) => {
        handleAxiosError(error);
      });
    },
  },
  mounted() {
    EventBus.$on("make-admin", (payload) => {
      this.changeUserRole(payload, 'admin');
    });

    EventBus.$on("make-super-admin", (payload) => {
      this.changeUserRole(payload, 'super_admin');
    });

    EventBus.$on("make-organisation-admin", (payload) => {
      this.changeUserRole(payload, 'organisation_admin');
    });

    EventBus.$on("make-standard", (payload) => {
      this.changeUserRole(payload, 'standard');
    });
  },
};
